import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import { Block } from "types/block";
import Error from "types/error";
import { generatePath } from "react-router-dom";

export default function useBlockFromLinkCode(code: string, enabled = true) {
  const request: Request = {
    url: generatePath(ENDPOINTS.links.blockFromCode, { code }),
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.links.blockFromCode, code],
    queryFn: () => client(request),
    enabled: enabled,
  };

  const { data, ...rest } = useQuery<Response<Block>, Error>(requestConfig);

  return { data, ...rest };
}
